// Termo de Uso e Aviso de Privacidade do IApauta — texto aprovado pelo Robson (21/10/2026).
// Fonte: documento "IApauta — Termo de Uso e Aviso de Privacidade" (Claude Docs). Ao mudar o
// texto, aumente TERMO_VERSAO (backend: TERMS_VERSION) — todos os usuários precisarão aceitar de novo.
export const TERMO_VERSAO = "1.1";
export const TERMO_DATA = "21/10/2026";

// Blocos: {k:"h", text} | {k:"p", r:[{t,b?,i?}]} | {k:"ul"|"ol", items:[runs]} | {k:"table", rows:[[runs]]}
export const TERMO_BLOCOS = [
 {
  "k": "h",
  "text": "Aceite e visão geral"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "Este Termo regula o uso do "
   },
   {
    "t": "IApauta",
    "b": 1
   },
   {
    "t": ", aplicativo de agenda de audiências e prazos para advogados, operado por Robson Machado Mendonça, advogado inscrito na OAB/SP sob o nº 252.280 (“IApauta”). Ao marcar “Li e aceito”, o usuário declara que "
   },
   {
    "t": "leu o Termo inteiro",
    "b": 1
   },
   {
    "t": " e concorda com ele. O botão de aceite só é liberado depois que a rolagem chega ao fim do texto."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "O que mais importa, em oito linhas (o texto completo abaixo prevalece):"
   }
  ]
 },
 {
  "k": "ul",
  "items": [
   [
    {
     "t": "Ferramenta de apoio.",
     "b": 1
    },
    {
     "t": " O IApauta sugere; o advogado confere. Prazos, datas e dados exigem sempre conferência própria nas fontes oficiais."
    }
   ],
   [
    {
     "t": "Pesquisas são do usuário.",
     "b": 1
    },
    {
     "t": " Toda consulta a tribunais, DJEN, DataJud e outros órgãos é feita sob responsabilidade exclusiva do usuário."
    }
   ],
   [
    {
     "t": "Dados obtidos.",
     "b": 1
    },
    {
     "t": " O que o usuário obtém e compartilha (com clientes, equipe ou terceiros) é de sua responsabilidade."
    }
   ],
   [
    {
     "t": "Acesso pessoal.",
     "b": 1
    },
    {
     "t": " Login e senha são intransferíveis. Compartilhar acesso ou funcionalidades exige autorização prévia e escrita do IApauta."
    }
   ],
   [
    {
     "t": "OAB travada.",
     "b": 1
    },
    {
     "t": " Após o cadastro, a OAB não pode ser trocada nem acrescentada sem pedido aprovado pelo administrador."
    }
   ],
   [
    {
     "t": "Dados pessoais.",
     "b": 1
    },
    {
     "t": " Tratamos nome, OAB, CPF e dados de uso conforme a LGPD, com as medidas descritas na seção 6."
    }
   ],
   [
    {
     "t": "Inteligência artificial.",
     "b": 1
    },
    {
     "t": " Textos podem ser lidos por IA, com mascaramento de nomes; o resultado é sempre sugestão."
    }
   ],
   [
    {
     "t": "Marca e software.",
     "b": 1
    },
    {
     "t": " A marca IApauta, o código e o conteúdo do app são protegidos."
    }
   ]
  ]
 },
 {
  "k": "h",
  "text": "1. O serviço e seus limites"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "1.1. O IApauta organiza audiências, prazos e movimentações: cadastra eventos, cria lembretes no Google Calendário, avisa clientes e equipe e, quando o usuário ativa, lê publicações do DJEN e movimentações do DataJud para sugerir audiências e prazos."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "1.2. "
   },
   {
    "t": "O IApauta é ferramenta de apoio. Não presta serviço jurídico e não substitui a diligência do advogado.",
    "b": 1
   },
   {
    "t": " O usuário deve conferir prazos, datas, horários, partes e tribunal diretamente nas fontes oficiais (DJEN, diários, sistemas dos tribunais) antes de qualquer providência."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "1.3. Datas e prazos calculados pelo app são "
   },
   {
    "t": "sugestões",
    "b": 1
   },
   {
    "t": ". O cálculo pode não considerar feriados (nacionais, estaduais ou municipais), suspensões e prorrogações decretadas por cada tribunal, nem regras especiais de contagem."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "1.4. O serviço depende de terceiros fora do nosso controle (CNJ, DJEN, DataJud, Google, provedores de e-mail, hospedagem e IA). Falhas, atrasos, bloqueios ou mudanças nessas fontes podem causar ausência ou atraso de avisos. "
   },
   {
    "t": "A falta de uma publicação, aviso ou lembrete no app não dispensa o usuário de acompanhar seus processos por conta própria.",
    "b": 1
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "1.5. O app não acessa sistemas de tribunais com senha ou certificado digital do usuário e não protocola peças. O envio por WhatsApp é manual (o app abre a mensagem pronta; quem envia é o usuário)."
   }
  ]
 },
 {
  "k": "h",
  "text": "2. Cadastro e OAB"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "2.1. O cadastro exige "
   },
   {
    "t": "nome completo, número e UF da OAB e CPF",
    "b": 1
   },
   {
    "t": ", todos verdadeiros, completos e do próprio usuário. O usuário responde pela veracidade e mantém os dados atualizados."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "2.2. "
   },
   {
    "t": "A OAB informada no cadastro fica travada.",
    "b": 1
   },
   {
    "t": " Depois do cadastro, o usuário não pode alterar nem incluir outra inscrição por conta própria. Para incluir nova OAB (por exemplo, inscrição suplementar), deve abrir uma "
   },
   {
    "t": "solicitação de alteração",
    "b": 1
   },
   {
    "t": " no app, que depende de "
   },
   {
    "t": "aprovação do administrador",
    "b": 1
   },
   {
    "t": " do IApauta."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "2.3. O IApauta pode pedir comprovação de que a OAB pertence ao usuário (por exemplo, consulta ao cadastro nacional dos advogados) e recusar ou suspender o cadastro se houver divergência, uso de OAB de terceiro sem autorização, ou suspeita de fraude."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "2.4. É proibido cadastrar a OAB de terceiros para monitorá-los (por exemplo, concorrentes), salvo autorização expressa do titular da inscrição e do IApauta. A OAB de sócio ou colega só pode ser usada com a autorização dele, que o usuário deve guardar."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "2.5. O usuário declara ser advogado regularmente inscrito na OAB, ou pessoa autorizada por ele, e usar o app em atividade profissional lícita."
   }
  ]
 },
 {
  "k": "h",
  "text": "3. Acesso pessoal e intransferível"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.1. O IApauta concede ao usuário uma "
   },
   {
    "t": "licença de uso pessoal, limitada, revogável, não exclusiva e intransferível",
    "b": 1
   },
   {
    "t": ", enquanto o cadastro estiver ativo e este Termo for cumprido. O app é licenciado, não vendido."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.2. "
   },
   {
    "t": "Login e senha são pessoais.",
    "b": 1
   },
   {
    "t": " É proibido compartilhar, emprestar, vender ou divulgar o acesso, a conta, a senha, o token do feed de calendário ou os links privados a "
   },
   {
    "t": "qualquer terceiro",
    "b": 1
   },
   {
    "t": " (colega, estagiário, cliente, outro escritório), sem "
   },
   {
    "t": "autorização prévia e escrita do IApauta",
    "b": 1
   },
   {
    "t": ". Uma conta serve a uma pessoa, e uma OAB, a um usuário."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.3. O usuário responde por tudo o que for feito com o seu acesso e deve avisar o IApauta imediatamente se suspeitar de uso indevido, perda ou vazamento de credenciais."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.4. É proibido, sem autorização prévia e escrita do IApauta: (a) revender, sublicenciar, alugar ou oferecer o app, ou suas funcionalidades, a terceiros; (b) copiar, reproduzir, extrair em massa, fazer engenharia reversa, descompilar ou tentar obter o código-fonte; (c) usar robôs, scripts ou raspagem contra o app; (d) usar o app para construir serviço concorrente; (e) tentar burlar limites, permissões ou controles de segurança; (f) sobrecarregar o app ou as fontes que ele consulta."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.5. Quando o IApauta oferecer contas de equipe, o administrador do escritório poderá convidar pessoas e definir permissões por módulo (por exemplo, financeiro, contencioso, preventivo). Cada pessoa usa "
   },
   {
    "t": "o seu próprio acesso",
    "b": 1
   },
   {
    "t": ", e o administrador responde pelos convites e pelos limites que definir."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "3.6. O IApauta pode suspender ou bloquear imediatamente o acesso em caso de uso simultâneo anômalo, compartilhamento de credenciais ou violação deste Termo, sem prejuízo de outras medidas cabíveis."
   }
  ]
 },
 {
  "k": "h",
  "text": "4. Consultas a órgãos públicos e fontes oficiais"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.1. As pesquisas e consultas feitas por meio do IApauta são de responsabilidade exclusiva do usuário.",
    "b": 1
   },
   {
    "t": " O app executa as buscas que o usuário configura (OAB, nome do advogado, números de processo, tribunais) em fontes públicas, como o DJEN, o DataJud e as publicações dos tribunais. O usuário decide o que monitorar e responde pelo que decide."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.2. O usuário declara que monitora "
   },
   {
    "t": "apenas",
    "b": 1
   },
   {
    "t": " as suas inscrições na OAB e os processos em que atua ou está autorizado a atuar, e que usa o resultado exclusivamente na sua atividade profissional. "
   },
   {
    "t": "É proibido",
    "b": 1
   },
   {
    "t": " usar o app para: (a) acompanhar processos ou pessoas sem vínculo profissional; (b) monitorar advogados concorrentes ou terceiros; (c) formar bancos de dados de pessoas; (d) qualquer finalidade ilegal, abusiva ou incompatível com a finalidade pela qual o órgão disponibiliza a informação."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.3. O usuário deve respeitar os "
   },
   {
    "t": "termos de uso, limites e restrições de cada fonte",
    "b": 1
   },
   {
    "t": " (por exemplo, os Termos de Uso da API pública do DataJud, que limitam o volume de requisições, vedam a exploração comercial da API e restringem o compartilhamento de dados pessoais), as normas do CNJ sobre publicidade processual e a LGPD. A informação ser pública "
   },
   {
    "t": "não autoriza qualquer uso",
    "b": 1
   },
   {
    "t": ": o uso posterior precisa ser compatível com a finalidade da publicidade."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.4. "
   },
   {
    "t": "Segredo de justiça e sigilo.",
    "b": 1
   },
   {
    "t": " Se o conteúdo chegar ao app de processo sob segredo de justiça ou sigilo, o usuário responde por mantê-lo restrito a quem tem direito de acesso e por não o divulgar."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.5. O usuário não deve fornecer ao app senhas, certificados digitais ou tokens de sistemas de tribunais, e o app não os solicita."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.6. O IApauta não controla, não garante e não responde pela "
   },
   {
    "t": "disponibilidade, exatidão, completude ou atualização",
    "b": 1
   },
   {
    "t": " das fontes oficiais, nem pelas decisões de bloqueio, limitação ou revogação de acesso tomadas por elas. O IApauta pode espaçar, limitar ou suspender consultas para respeitar os limites das fontes ou por ordem de autoridade, sem que isso gere direito a indenização."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "4.7. Qualquer sanção, bloqueio, reclamação ou dano decorrente de uso indevido das fontes oficiais por parte do usuário é de responsabilidade dele, nos termos da seção 9."
   }
  ]
 },
 {
  "k": "h",
  "text": "5. Dados de clientes, sigilo e compartilhamento"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.1. Os dados de clientes, processos e eventos que o usuário cadastra ou importa são "
   },
   {
    "t": "dele",
    "b": 1
   },
   {
    "t": ". Em relação a esses dados, o usuário é o "
   },
   {
    "t": "controlador",
    "b": 1
   },
   {
    "t": " (LGPD) e o IApauta atua como "
   },
   {
    "t": "operador",
    "b": 1
   },
   {
    "t": ", tratando-os somente para prestar o serviço e seguindo as instruções do usuário."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.2. "
   },
   {
    "t": "O sigilo profissional é do advogado",
    "b": 1
   },
   {
    "t": " (Estatuto da Advocacia, art. 34, VII). O usuário decide quais dados insere no app, tem a base legal e, quando necessário, o consentimento dos seus clientes, e responde por isso. Quando o app enviar avisos a clientes ou a equipe (e-mail, WhatsApp, link de confirmação), "
   },
   {
    "t": "quem decide enviar, para quem e com qual conteúdo é o usuário",
    "b": 1
   },
   {
    "t": "."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.3. "
   },
   {
    "t": "Compartilhamento dos dados obtidos.",
    "b": 1
   },
   {
    "t": " O usuário responde, com exclusividade, pelo uso e pela divulgação de tudo o que obtiver pelo app (publicações, movimentações, atas, dados de partes e de terceiros), inclusive quando compartilhar com clientes, equipe, outros escritórios, redes sociais ou qualquer terceiro. É proibido: (a) divulgar dados pessoais de partes ou de terceiros além do necessário à atuação profissional; (b) revender, publicar ou distribuir os dados obtidos como produto ou base de dados; (c) compartilhar conteúdo de processos em segredo de justiça."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.4. "
   },
   {
    "t": "Links e feeds públicos.",
    "b": 1
   },
   {
    "t": " Links de confirmação de presença, avisos de equipe e o feed de calendário funcionam "
   },
   {
    "t": "sem login",
    "b": 1
   },
   {
    "t": ": quem tem o link vê os dados da audiência vinculada. O usuário deve enviá-los só a quem deve recebê-los e não publicá-los. O IApauta não responde por links repassados, encaminhados ou divulgados pelo usuário ou por quem o recebeu."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.5. "
   },
   {
    "t": "Inteligência artificial e clientes.",
    "b": 1
   },
   {
    "t": " Se o usuário usar a leitura por IA com dados de casos, é dele a obrigação de informar seus clientes e obter o consentimento que a Recomendação 001/2024 do Conselho Federal da OAB indica (ver seção 7)."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.6. O IApauta não acessa o conteúdo dos dados do usuário, exceto: (a) para prestação do serviço e suporte pedido por ele; (b) por segurança, prevenção a fraude ou cumprimento de ordem legal; (c) de forma agregada e sem identificação, para medir e melhorar o serviço."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "5.7. "
   },
   {
    "t": "Mensagens internas.",
    "b": 1
   },
   {
    "t": " As mensagens do IApauta servem para o trabalho do usuário com a sua Equipe e com colegas que ele vincula (com aceite dos dois lados, desfazível a qualquer momento). Cada pessoa responde pelo que escreve, pelo sigilo profissional e pelo consentimento dos clientes; o usuário deve colocar nas mensagens só os dados de clientes que forem necessários e não pode usar o recurso para assédio, spam ou conteúdo ilícito. Os anexos mostram apenas um resumo (data, hora, juízo e número do processo), sem nome de cliente ou partes. Não há envio de arquivos. As mensagens ficam por até 90 dias e depois são apagadas. O aviso por push não leva o texto. Quem da Equipe não tem conta vinculada recebe a mensagem por e-mail, por escolha do usuário que a envia. O IApauta não lê as mensagens, salvo nas hipóteses da cláusula 5.6."
   }
  ]
 },
 {
  "k": "h",
  "text": "6. Proteção de dados pessoais (LGPD)"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.1. "
   },
   {
    "t": "Papéis.",
    "b": 1
   },
   {
    "t": " Dos dados da conta do próprio usuário (nome, e-mail, OAB, CPF, registros de acesso), o IApauta é "
   },
   {
    "t": "controlador",
    "b": 1
   },
   {
    "t": ". Dos dados de clientes, processos e terceiros que o usuário insere ou importa, o IApauta é "
   },
   {
    "t": "operador",
    "b": 1
   },
   {
    "t": " e o usuário é o controlador (seção 5)."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.2. "
   },
   {
    "t": "Dados que tratamos e para quê.",
    "b": 1
   }
  ]
 },
 {
  "k": "table",
  "rows": [
   [
    [
     {
      "t": "Dado"
     }
    ],
    [
     {
      "t": "Finalidade"
     }
    ],
    [
     {
      "t": "Base legal (LGPD, art. 7º)"
     }
    ]
   ],
   [
    [
     {
      "t": "Nome, e-mail, foto do perfil Google"
     }
    ],
    [
     {
      "t": "Criar e autenticar a conta; identificar o usuário"
     }
    ],
    [
     {
      "t": "Execução de contrato (V)"
     }
    ]
   ],
   [
    [
     {
      "t": "OAB e UF"
     }
    ],
    [
     {
      "t": "Monitorar publicações do próprio usuário; verificar titularidade"
     }
    ],
    [
     {
      "t": "Execução de contrato (V); legítimo interesse (IX)"
     }
    ]
   ],
   [
    [
     {
      "t": "CPF"
     }
    ],
    [
     {
      "t": "Identificar o usuário de forma única, evitar contas duplicadas e fraude, e conferir a titularidade da OAB"
     }
    ],
    [
     {
      "t": "Legítimo interesse (IX); execução de contrato (V)"
     }
    ]
   ],
   [
    [
     {
      "t": "Token de acesso ao Google Calendário"
     }
    ],
    [
     {
      "t": "Criar, alterar e apagar os eventos do próprio usuário"
     }
    ],
    [
     {
      "t": "Execução de contrato (V); consentimento no login Google"
     }
    ]
   ],
   [
    [
     {
      "t": "Registros de acesso (IP, data e hora, navegador)"
     }
    ],
    [
     {
      "t": "Segurança, prevenção a fraude e cumprimento de ordem legal"
     }
    ],
    [
     {
      "t": "Obrigação legal (II); legítimo interesse (IX)"
     }
    ]
   ],
   [
    [
     {
      "t": "Clientes, processos, audiências, prazos e textos de publicações"
     }
    ],
    [
     {
      "t": "Prestar o serviço ao usuário (como operador)"
     }
    ],
    [
     {
      "t": "Instrução do controlador (o usuário)"
     }
    ]
   ]
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.3. "
   },
   {
    "t": "CPF: cuidado reforçado.",
    "b": 1
   },
   {
    "t": " O CPF é usado só para as finalidades da tabela. Não é vendido, cedido nem usado para marketing. Fica "
   },
   {
    "t": "cifrado no banco de dados",
    "b": 1
   },
   {
    "t": ", aparece "
   },
   {
    "t": "mascarado",
    "b": 1
   },
   {
    "t": " na tela (apenas os dígitos do meio, no formato XXX.123.456-XX), só é lido por quem precisa dele na operação do IApauta, e "
   },
   {
    "t": "nunca é enviado à IA, aos e-mails de aviso ou a qualquer fonte consultada",
    "b": 1
   },
   {
    "t": "."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.4. "
   },
   {
    "t": "Com quem os dados passam (operadores e fornecedores).",
    "b": 1
   }
  ]
 },
 {
  "k": "table",
  "rows": [
   [
    [
     {
      "t": "Fornecedor"
     }
    ],
    [
     {
      "t": "Para quê"
     }
    ],
    [
     {
      "t": "Onde"
     }
    ],
    [
     {
      "t": "Dados"
     }
    ]
   ],
   [
    [
     {
      "t": "Fly.io"
     }
    ],
    [
     {
      "t": "Hospedagem do aplicativo"
     }
    ],
    [
     {
      "t": "Brasil (São Paulo)"
     }
    ],
    [
     {
      "t": "Todos, em trânsito"
     }
    ]
   ],
   [
    [
     {
      "t": "MongoDB Atlas"
     }
    ],
    [
     {
      "t": "Banco de dados"
     }
    ],
    [
     {
      "t": "Brasil (São Paulo)"
     }
    ],
    [
     {
      "t": "Todos, armazenados"
     }
    ]
   ],
   [
    [
     {
      "t": "Google (login e Calendário)"
     }
    ],
    [
     {
      "t": "Autenticação e agenda do usuário"
     }
    ],
    [
     {
      "t": "EUA e outros países"
     }
    ],
    [
     {
      "t": "Conta Google e eventos"
     }
    ]
   ],
   [
    [
     {
      "t": "Anthropic (IA Claude)"
     }
    ],
    [
     {
      "t": "Ler textos de publicações e atas e sugerir dados"
     }
    ],
    [
     {
      "t": "EUA"
     }
    ],
    [
     {
      "t": "Texto da publicação, com nomes mascarados (seção 7)"
     }
    ]
   ],
   [
    [
     {
      "t": "Resend"
     }
    ],
    [
     {
      "t": "Envio de e-mails de aviso"
     }
    ],
    [
     {
      "t": "EUA"
     }
    ],
    [
     {
      "t": "Nome e e-mail do destinatário, conteúdo do aviso"
     }
    ]
   ],
   [
    [
     {
      "t": "Serviços de notificação do navegador (Web Push)"
     }
    ],
    [
     {
      "t": "Avisos no aparelho do usuário"
     }
    ],
    [
     {
      "t": "Países diversos"
     }
    ],
    [
     {
      "t": "Endereço técnico do aparelho e título do aviso"
     }
    ]
   ],
   [
    [
     {
      "t": "IPRoyal (proxy)"
     }
    ],
    [
     {
      "t": "Acessar o DJEN a partir do Brasil"
     }
    ],
    [
     {
      "t": "Brasil"
     }
    ],
    [
     {
      "t": "Apenas a consulta pública; não recebe dados de clientes"
     }
    ]
   ]
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "Novos fornecedores podem ser acrescentados com aviso ao usuário. Os fornecedores no exterior implicam "
   },
   {
    "t": "transferência internacional",
    "b": 1
   },
   {
    "t": ", feita com base nas cláusulas-padrão da ANPD (Resolução CD/ANPD 19/2024) ou em outra hipótese do art. 33 da LGPD."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.5. "
   },
   {
    "t": "Segurança.",
    "b": 1
   },
   {
    "t": " Adotamos medidas técnicas e administrativas compatíveis com o risco: conexão cifrada (HTTPS), isolamento dos dados de cada conta, login por Google, sessões com expiração, controle de acesso do administrador, cifra de campos sensíveis, cópias de segurança, registro de acessos e mascaramento de nomes antes de enviar texto à IA. Nenhum sistema é à prova de falhas: o usuário também deve proteger o seu aparelho, a sua conta Google e a sua senha."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.6. "
   },
   {
    "t": "Incidentes.",
    "b": 1
   },
   {
    "t": " Em caso de incidente de segurança com risco ou dano relevante, o IApauta avisará o usuário e, quando exigido, a ANPD, nos prazos da regulação (3 dias úteis, pela Resolução CD/ANPD 15/2024). Quando o usuário for o controlador dos dados atingidos, é dele o dever de avisar os titulares e a ANPD, e o IApauta o ajudará com as informações necessárias."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.7. "
   },
   {
    "t": "Direitos do titular.",
    "b": 1
   },
   {
    "t": " O titular dos dados da conta pode pedir confirmação do tratamento, acesso, correção, anonimização, eliminação, portabilidade, informação sobre compartilhamento e revogação do consentimento (art. 18). Pedidos ao "
   },
   {
    "t": "encarregado",
    "b": 1
   },
   {
    "t": ": Robson Machado Mendonça (OAB/SP 252.280), pelo e-mail robsonpontaladv@gmail.com. Respondemos em até 15 dias. Titulares de dados inseridos por um usuário (clientes, partes) devem se dirigir primeiro ao advogado responsável; o IApauta o ajuda a atender."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.8. "
   },
   {
    "t": "Guarda e eliminação.",
    "b": 1
   },
   {
    "t": " Mantemos os dados da conta enquanto ela estiver ativa. Ao encerrar, eliminamos ou anonimizamos os dados em até 30 dias, salvo o que a lei obrigar a guardar (por exemplo, registros de acesso por 6 meses, Marco Civil da Internet, art. 15) ou o necessário para defesa em processo. Textos de publicações recebidas ficam por até 1 ano e mensagens internas por até 90 dias. Backups são renovados em ciclos e eliminam os dados em até 60 dias."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "6.9. "
   },
   {
    "t": "Dados sensíveis e de crianças.",
    "b": 1
   },
   {
    "t": " O IApauta não pede dados sensíveis nem de crianças e adolescentes. Se o conteúdo dos processos os trouxer, o usuário, como controlador, responde pela base legal e pelos cuidados exigidos (LGPD, arts. 11 e 14)."
   }
  ]
 },
 {
  "k": "h",
  "text": "7. Inteligência artificial"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.1. O IApauta usa inteligência artificial (modelo Claude, da Anthropic) para ler textos de publicações e atas colados no app e "
   },
   {
    "t": "sugerir",
    "b": 1
   },
   {
    "t": " dados, como audiência, data, hora, partes, tribunal e prazos."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.2. "
   },
   {
    "t": "Mascaramento.",
    "b": 1
   },
   {
    "t": " Antes do envio, o app substitui nomes de pessoas por marcadores. Processos que o usuário indicar como segredo de justiça não são enviados à IA. O CPF e os dados de contato nunca vão à IA."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.3. "
   },
   {
    "t": "A IA pode errar",
    "b": 1
   },
   {
    "t": ": data ou tribunal trocados, prazo mal interpretado, ato não detectado. Por isso o resultado é sempre uma sugestão, que passa pela fila “Para validar”. "
   },
   {
    "t": "O usuário deve conferir integralmente cada sugestão antes de confiar nela.",
    "b": 1
   },
   {
    "t": " A responsabilidade pela decisão e pela petição continua sendo do advogado."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.4. O IApauta usa a IA por contrato comercial de API e, segundo os termos do fornecedor vigentes nesta data, o conteúdo enviado por API não é usado para treinar os modelos. O envio ao exterior é uma transferência internacional (seção 6.4)."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.5. "
   },
   {
    "t": "Clientes.",
    "b": 1
   },
   {
    "t": " A Recomendação 001/2024 do Conselho Federal da OAB orienta o advogado a informar o cliente sobre o uso de IA e a obter consentimento informado. Essa obrigação é "
   },
   {
    "t": "do usuário",
    "b": 1
   },
   {
    "t": ". Ao usar a leitura por IA com dados de um caso, o usuário declara que cumpriu essa orientação."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "7.6. O usuário pode desativar as funções de IA nas Configurações e continuar usando o app com cadastro manual."
   }
  ]
 },
 {
  "k": "h",
  "text": "8. Marca e propriedade intelectual"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.1. "
   },
   {
    "t": "IApauta",
    "b": 1
   },
   {
    "t": ", o logotipo, o nome de domínio, o layout, os textos, o código-fonte, a estrutura do banco de dados, as funcionalidades e a documentação do aplicativo pertencem ao IApauta e são protegidos pela legislação de propriedade intelectual: Lei de Software (Lei 9.609/1998), Lei de Direitos Autorais (Lei 9.610/1998) e Lei da Propriedade Industrial (Lei 9.279/1996). O programa de computador recebe a proteção dada às obras literárias, e o seu uso no país depende de contrato de licença (Lei 9.609/1998, arts. 2º e 9º). Este Termo é esse contrato."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.2. Este Termo "
   },
   {
    "t": "não transfere",
    "b": 1
   },
   {
    "t": " ao usuário nenhum direito sobre a marca ou o software, além da licença de uso da seção 3."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.3. "
   },
   {
    "t": "Sem autorização prévia e escrita do IApauta, é proibido",
    "b": 1
   },
   {
    "t": ": (a) usar a marca, o nome, o logotipo ou a identidade visual, inclusive em propaganda, perfis, domínios, nomes de empresa ou produtos; (b) registrar ou usar nome, marca ou domínio igual ou semelhante que possa causar confusão; (c) sugerir parceria, patrocínio ou endosso do IApauta; (d) divulgar, a quem não for usuário autorizado, o funcionamento, as telas, os fluxos e as funcionalidades do app, a documentação ou materiais não públicos, para fins comerciais, concorrenciais ou de criação de produto semelhante; (e) copiar ou reproduzir o app, no todo ou em parte."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.4. O usuário pode citar que usa o IApauta, sem sugerir endosso e sem alterar a marca. Capturas de tela só podem ser divulgadas sem dados de clientes, de partes ou de terceiros."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.5. "
   },
   {
    "t": "Conteúdo do usuário.",
    "b": 1
   },
   {
    "t": " Os dados que o usuário insere continuam sendo dele. O usuário concede ao IApauta, durante a conta, a licença limitada necessária para armazenar e tratar esses dados e prestar o serviço."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.6. "
   },
   {
    "t": "Sugestões.",
    "b": 1
   },
   {
    "t": " Ideias, pedidos e feedback enviados pelo usuário podem ser usados pelo IApauta sem custo, sem que isso gere direito a remuneração, coautoria ou participação."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "8.7. A violação desta seção permite a suspensão imediata do acesso, a cobrança de perdas e danos, a cessação do uso indevido e as demais medidas civis e penais cabíveis, inclusive as previstas na Lei 9.609/1998 (art. 12) e na Lei 9.279/1996."
   }
  ]
 },
 {
  "k": "h",
  "text": "9. Limitação de responsabilidade e indenização"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.1. O app é oferecido "
   },
   {
    "t": "no estado em que se encontra",
    "b": 1
   },
   {
    "t": ". Buscamos mantê-lo disponível e correto, mas não garantimos funcionamento ininterrupto, ausência de erros, nem exatidão, completude ou atualidade das informações de terceiros."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.2. "
   },
   {
    "t": "O acompanhamento dos prazos e dos processos é dever indelegável do advogado.",
    "b": 1
   },
   {
    "t": " O IApauta não responde por perda de prazo, não comparecimento a audiência, intimação não vista, ou qualquer ato ou omissão do usuário, de seus clientes ou de terceiros baseados em informação, sugestão, cálculo, lembrete ou aviso do app."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.3. O IApauta também não responde por: (a) falhas, bloqueios ou mudanças nas fontes e fornecedores externos (seções 1.4 e 4); (b) uso indevido do app, das fontes oficiais ou dos dados obtidos; (c) compartilhamento de login, senha, links ou dados pelo usuário; (d) dados inseridos pelo usuário e consentimentos que ele deveria ter obtido de seus clientes; (e) inaptidão do aparelho, da internet ou da conta Google do usuário; (f) caso fortuito ou força maior."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.4. Na máxima extensão permitida pela lei, a responsabilidade total do IApauta perante o usuário, por qualquer causa, fica limitada ao "
   },
   {
    "t": "valor pago pelo usuário nos 12 meses anteriores ao fato",
    "b": 1
   },
   {
    "t": " (ou R$ 1.000,00 se o uso for gratuito) e não inclui lucros cessantes, perda de chance, danos indiretos ou reputacionais."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.5. "
   },
   {
    "t": "Indenização.",
    "b": 1
   },
   {
    "t": " O usuário mantém o IApauta indene, e o ressarce, inclusive de custas e honorários advocatícios, por reclamações, sanções, multas e prejuízos de terceiros ou de autoridades decorrentes de: (a) violação deste Termo; (b) uso indevido das fontes oficiais ou dos dados obtidos; (c) descumprimento da LGPD, do sigilo profissional ou do dever de informar e obter consentimento de seus clientes; (d) compartilhamento de acesso; (e) violação da propriedade intelectual do IApauta ou de terceiros."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "9.6. Nada neste Termo exclui a responsabilidade que a lei não permite afastar, como dolo ou culpa grave, nem os direitos do titular de dados previstos na LGPD."
   }
  ]
 },
 {
  "k": "h",
  "text": "10. Suspensão, encerramento e disposições finais"
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.1. O IApauta pode "
   },
   {
    "t": "suspender ou encerrar",
    "b": 1
   },
   {
    "t": " a conta, com ou sem aviso prévio conforme a gravidade, em caso de violação deste Termo, compartilhamento de credenciais, suspeita de fraude, uso de OAB que não seja do usuário, ordem de autoridade ou risco à segurança. O usuário pode encerrar a conta quando quiser e deve exportar os seus dados antes. Depois disso vale a seção 6.8."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.2. "
   },
   {
    "t": "Alterações.",
    "b": 1
   },
   {
    "t": " O IApauta pode atualizar este Termo. Avisaremos pelo app e por e-mail com "
   },
   {
    "t": "15 dias de antecedência",
    "b": 1
   },
   {
    "t": "; mudanças relevantes (dados, IA, responsabilidade) exigem novo aceite. Quem não concordar pode encerrar a conta antes da vigência; continuar usando o app depois dela vale como aceite."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.3. "
   },
   {
    "t": "Registro do aceite.",
    "b": 1
   },
   {
    "t": " Guardamos a data, a hora, a versão do Termo e o IP do aceite, como prova do consentimento e para o exercício regular de direitos."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.4. "
   },
   {
    "t": "Comunicações.",
    "b": 1
   },
   {
    "t": " Avisos e notificações vão para o e-mail cadastrado e para o app. O usuário deve manter o e-mail atualizado."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.5. Se uma cláusula for considerada inválida, as demais continuam valendo. A tolerância do IApauta com um descumprimento não é renúncia. O usuário não pode ceder este contrato. Este Termo, com o Aviso de Privacidade da seção 6, é o acordo completo sobre o uso do app."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.6. "
   },
   {
    "t": "Lei e foro.",
    "b": 1
   },
   {
    "t": " Aplica-se a lei brasileira. Fica eleito o foro da comarca de Ribeirão Preto, Estado de São Paulo, com renúncia a qualquer outro, ressalvado o foro que a lei impuser como obrigatório."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "10.7. "
   },
   {
    "t": "Contato e encarregado:",
    "b": 1
   },
   {
    "t": " Robson Machado Mendonça, robsonpontaladv@gmail.com."
   }
  ]
 },
 {
  "k": "p",
  "r": [
   {
    "t": "Versão 1.0 — 21/10/2026.",
    "i": 1
   }
  ]
 }
];
